import { UserGetOneAdapter } from '../../../../adapter';

export default async function UserGetOneUseCase(event) {
    const { id } = event;

    const requestUrl = 'https://nwtbrglvql.execute-api.ap-southeast-1.amazonaws.com/api/procurement/user/get/one';

    const payload = {
        data: {
            userData: {
                id
            },
            signature: ''
        }
    };

    const result = await UserGetOneAdapter(requestUrl, JSON.stringify(payload));
    return result;
}
